/**
 * Authentication facade: Auth0 online, nothing offline. Import auth from here,
 * never from `@auth0/auth0-react` directly.
 */
import { IS_OFFLINE_BUILD } from '../Config/buildMode';
import * as auth0Adapter from './auth0Adapter';
import * as offlineAdapter from './offlineAdapter';

// Adapter selected at build time
const adapter = IS_OFFLINE_BUILD ? offlineAdapter : auth0Adapter;

export const AppAuthProvider = adapter.AppAuthProvider;
export const useAppAuth = adapter.useAppAuth;
export const withAppAuthRequired = adapter.withAppAuthRequired;
